/**
 * 角色卡列表项的几何（T07）。
 *
 * 抽出纯函数便于「渲染」与「清单登记」共用同一份坐标（安卓移植硬要求）。
 * 坐标 = 页面局部坐标（y 的 0 点是内容区顶部）。
 */
import type { BoxLayout } from '../../ui';
import { LIST_BOX, LIST_ITEM_STEP } from './layout';

export interface PresetItemBoxes {
  item: BoxLayout;
  avatar: BoxLayout;
  name: BoxLayout;
  tags: BoxLayout;
  description: BoxLayout;
  edit: BoxLayout;
  duplicate: BoxLayout;
  exportJson: BoxLayout;
  remove: BoxLayout;
}

/** 第 index 个列表项的几何（高 146，步进 158）。 */
export function presetItemBoxes(index: number): PresetItemBoxes {
  const top = LIST_BOX.y + 8 + index * LIST_ITEM_STEP;
  return {
    item: { x: 8, y: top, width: 374, height: 146 },
    avatar: { x: 16, y: top + 14, width: 64, height: 64 },
    name: { x: 92, y: top + 10, width: 276, height: 22 },
    tags: { x: 92, y: top + 36, width: 276, height: 18 },
    description: { x: 92, y: top + 58, width: 276, height: 38 },
    edit: { x: 92, y: top + 100, width: 64, height: 36 },
    duplicate: { x: 162, y: top + 100, width: 64, height: 36 },
    exportJson: { x: 232, y: top + 100, width: 64, height: 36 },
    remove: { x: 302, y: top + 100, width: 66, height: 36 },
  };
}

/** 列表项几何的行内常量（清单登记注释里引用，避免魔法数字散落）。 */
export const PRESET_ITEM_HEIGHT = 146;
export const PRESET_ITEM_STEP = 158;
